module.exports = __webpack_public_path__ + "media/images/emblems/Fiesch-coat_of_arms-35c2aeafbddf91b05037b902a86c0c5c.svg";